"use strict";

exports.__esModule = true;
exports.storeGlobalLocation = exports.setGlobalLocation = void 0;
var _utils = require("../utils");
var _types = require("./types");
var storeGlobalLocation = function storeGlobalLocation(payload) {
  (0, _utils.setCachedLocation)(payload);
  return {
    type: _types.STORE_GLOBAL_LOCATION,
    payload: payload
  };
};
exports.storeGlobalLocation = storeGlobalLocation;
var setGlobalLocation = function setGlobalLocation(payload) {
  return {
    type: _types.SET_GLOBAL_LOCATION,
    payload: payload
  };
};
exports.setGlobalLocation = setGlobalLocation;